// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook, createActionsHook } from '@atlassian/react-sweet-state';
import { actions } from './actions.tsx';
import type { State } from './types.tsx';

export type Actions = typeof actions;

const initialState: State = {
	isModalOpenViaAddView: false,
};

const Store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'add-shortcut-modal',
});

export const useSimplifyNavExperimentActions = createActionsHook(Store);

const getIsModalOpenViaAddView = (state: State) => state.isModalOpenViaAddView;

export const useIsModalOpenViaAddView = createHook(Store, {
	selector: getIsModalOpenViaAddView,
});
